var tmYesNoModalEl = $('#yes-no-modal');

tmYesNoModal = function () {
    return {
        onClosedModalTrigger: '',
        rightBtnClickTrigger: '',

        showModal: function (title, body, leftBtnText, rightBtnText, onClosedModalTrigger = '', rightBtnClickTrigger = '') {
            tmYesNoModal.onClosedModalTrigger = onClosedModalTrigger;
            tmYesNoModal.rightBtnClickTrigger = rightBtnClickTrigger;
            tmYesNoModalEl.find('#yes-no-modal-heading').text(title);
            tmYesNoModalEl.find('#yes-no-modal-body').text(body);
            tmYesNoModalEl.find('#yes-no-modal-left-btn').text(leftBtnText);
            tmYesNoModalEl.find('#yes-no-modal-right-btn').text(rightBtnText);
            tmYesNoModalEl.css('display', 'flex');
            $("body").css("overflow","hidden");
        },

        hideModal: function () {
            if (tmYesNoModalEl.is(':visible')) {
                $('#yes-no-modal #yes-no-modal-right-btn').attr('disabled', false);
                if (tmYesNoModal.onClosedModalTrigger.length > 0) {
                    $(document).trigger(tmYesNoModal.onClosedModalTrigger);
                }
                tmYesNoModalEl.css('display', 'none');
                $("body").css("overflow","auto");
            }
        },
    }
}(window);


/* Left/Right Btn click events */
$('#yes-no-modal #yes-no-modal-left-btn').click(function(){
    tmYesNoModal.hideModal();
});
$('#yes-no-modal #yes-no-modal-right-btn').click(function(){
    $(this).attr('disabled', true);
    if (tmYesNoModal.rightBtnClickTrigger.length > 0) {
        $(document).trigger(tmYesNoModal.rightBtnClickTrigger);
    }
});


/* Hide Modal Listeners */
$('#yes-no-modal .modal-close').click(function(){
    tmYesNoModal.hideModal();
});
$(document).click(function(e){
    if (
        !(
            $(e.target).parents('#yes-no-modal .display-contents-inner').length
            || $(e.target).is('#yes-no-modal .display-contents-inner')
            || $(e.target).parents('.wishlist-items-grid .delete-wishlist').length
            || $(e.target).is('.wishlist-items-grid .delete-wishlist')
        )
    ) {
        tmYesNoModal.hideModal();
    }
});
